import { useState, useEffect } from 'react';

export default function Hero() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatDate = (date: Date) => {
    const options: Intl.DateTimeFormatOptions = { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    };
    return date.toLocaleDateString('en-US', options);
  };

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit', 
      second: '2-digit',
      hour12: true 
    });
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/410483e4cd50c8f99cd107c6a5d8a116.jpg" 
          alt="Downtown Roseville California" 
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="text-center px-6 w-full max-w-4xl">
          {/* Live Date/Time Display */}
          <div className="mb-6 flex justify-center">
            <div className="bg-white/10 backdrop-blur-md rounded-lg px-6 py-3 border border-white/20 inline-block">
              <p className="text-lg font-semibold text-white mb-1">{formatDate(currentTime)}</p>
              <p className="text-2xl font-bold text-white">{formatTime(currentTime)}</p>
            </div>
          </div>

          <div className="text-7xl md:text-8xl lg:text-9xl font-bold text-white mb-6 leading-tight">
            Discover<br />Roseville
          </div>
          <p className="text-xl md:text-2xl text-white/90 max-w-2xl mx-auto font-light mb-4">
            Where Northern California Charm Meets Modern Living
          </p>
          
          {/* Quick Stats with Sources */}
          <div className="flex flex-wrap justify-center gap-6 mb-8 max-w-3xl mx-auto hero-stats">
            <div className="bg-white/10 backdrop-blur-md rounded-lg px-4 py-3 border border-white/20">
              <p className="text-2xl font-bold text-white">147,000+</p>
              <p className="text-xs text-white/80">Population</p>
              <p className="text-[10px] text-white/60 mt-0.5">U.S. Census 2024</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-lg px-4 py-3 border border-white/20">
              <p className="text-2xl font-bold text-white">269</p>
              <p className="text-xs text-white/80">Sunny Days/Year</p>
              <p className="text-[10px] text-white/60 mt-0.5">U.S. Climate Data</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-lg px-4 py-3 border border-white/20">
              <p className="text-2xl font-bold text-white">80+</p>
              <p className="text-xs text-white/80">Parks & Trails</p>
              <p className="text-[10px] text-white/60 mt-0.5">City of Roseville</p>
            </div>
          </div>

          <a 
            href="/submit-business" 
            className="inline-flex items-center gap-2 bg-white text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-store-2-line text-xl"></i>
            List your Business for Free
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}